/** 区号元数据（名称见 i18n areaCodes） */
export const AREA_CODE_LIST = [
  {
    "id": 1,
    "area_code": "86",
    "is_hot": 1,
    "first_letter": "Z",
    "sort": 1
  },
  {
    "id": 2,
    "area_code": "852",
    "is_hot": 1,
    "first_letter": "Z",
    "sort": 1
  },
  {
    "id": 3,
    "area_code": "886",
    "is_hot": 1,
    "first_letter": "Z",
    "sort": 1
  },
  {
    "id": 4,
    "area_code": "1",
    "is_hot": 1,
    "first_letter": "M",
    "sort": 1
  },
  {
    "id": 7,
    "area_code": "853",
    "is_hot": 1,
    "first_letter": "Z",
    "sort": 1
  },
  {
    "id": 8,
    "area_code": "376",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 9,
    "area_code": "971",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 10,
    "area_code": "93",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 11,
    "area_code": "1268",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 12,
    "area_code": "1264",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 13,
    "area_code": "355",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 14,
    "area_code": "374",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 15,
    "area_code": "247",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 16,
    "area_code": "244",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 17,
    "area_code": "54",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 18,
    "area_code": "43",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 19,
    "area_code": "61",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 20,
    "area_code": "994",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 21,
    "area_code": "1246",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 22,
    "area_code": "880",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 23,
    "area_code": "32",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 24,
    "area_code": "226",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 25,
    "area_code": "359",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 26,
    "area_code": "973",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 27,
    "area_code": "257",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 28,
    "area_code": "229",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 29,
    "area_code": "970",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 30,
    "area_code": "1441",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 31,
    "area_code": "673",
    "is_hot": 0,
    "first_letter": "W",
    "sort": 0
  },
  {
    "id": 32,
    "area_code": "591",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 33,
    "area_code": "55",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 34,
    "area_code": "1242",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 35,
    "area_code": "267",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 36,
    "area_code": "375",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 37,
    "area_code": "501",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 38,
    "area_code": "1",
    "is_hot": 0,
    "first_letter": "J",
    "sort": 0
  },
  {
    "id": 39,
    "area_code": "1345",
    "is_hot": 0,
    "first_letter": "K",
    "sort": 0
  },
  {
    "id": 40,
    "area_code": "236",
    "is_hot": 0,
    "first_letter": "Z",
    "sort": 0
  },
  {
    "id": 41,
    "area_code": "242",
    "is_hot": 0,
    "first_letter": "G",
    "sort": 0
  },
  {
    "id": 42,
    "area_code": "41",
    "is_hot": 0,
    "first_letter": "R",
    "sort": 0
  },
  {
    "id": 43,
    "area_code": "682",
    "is_hot": 0,
    "first_letter": "K",
    "sort": 0
  },
  {
    "id": 44,
    "area_code": "56",
    "is_hot": 0,
    "first_letter": "Z",
    "sort": 0
  },
  {
    "id": 45,
    "area_code": "237",
    "is_hot": 0,
    "first_letter": "K",
    "sort": 0
  },
  {
    "id": 46,
    "area_code": "57",
    "is_hot": 0,
    "first_letter": "G",
    "sort": 0
  },
  {
    "id": 47,
    "area_code": "506",
    "is_hot": 0,
    "first_letter": "G",
    "sort": 0
  },
  {
    "id": 48,
    "area_code": "53",
    "is_hot": 0,
    "first_letter": "G",
    "sort": 0
  },
  {
    "id": 49,
    "area_code": "357",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 50,
    "area_code": "420",
    "is_hot": 0,
    "first_letter": "J",
    "sort": 0
  },
  {
    "id": 51,
    "area_code": "49",
    "is_hot": 0,
    "first_letter": "D",
    "sort": 0
  },
  {
    "id": 52,
    "area_code": "253",
    "is_hot": 0,
    "first_letter": "J",
    "sort": 0
  },
  {
    "id": 53,
    "area_code": "45",
    "is_hot": 0,
    "first_letter": "D",
    "sort": 0
  },
  {
    "id": 54,
    "area_code": "1890",
    "is_hot": 0,
    "first_letter": "D",
    "sort": 0
  },
  {
    "id": 55,
    "area_code": "213",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 56,
    "area_code": "593",
    "is_hot": 0,
    "first_letter": "E",
    "sort": 0
  },
  {
    "id": 57,
    "area_code": "372",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 58,
    "area_code": "20",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 59,
    "area_code": "34",
    "is_hot": 0,
    "first_letter": "X",
    "sort": 0
  },
  {
    "id": 60,
    "area_code": "251",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 61,
    "area_code": "358",
    "is_hot": 0,
    "first_letter": "F",
    "sort": 0
  },
  {
    "id": 62,
    "area_code": "679",
    "is_hot": 0,
    "first_letter": "F",
    "sort": 0
  },
  {
    "id": 63,
    "area_code": "33",
    "is_hot": 0,
    "first_letter": "F",
    "sort": 0
  },
  {
    "id": 64,
    "area_code": "241",
    "is_hot": 0,
    "first_letter": "J",
    "sort": 0
  },
  {
    "id": 65,
    "area_code": "44",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 66,
    "area_code": "1809",
    "is_hot": 0,
    "first_letter": "G",
    "sort": 0
  },
  {
    "id": 67,
    "area_code": "995",
    "is_hot": 0,
    "first_letter": "G",
    "sort": 0
  },
  {
    "id": 68,
    "area_code": "594",
    "is_hot": 0,
    "first_letter": "F",
    "sort": 0
  },
  {
    "id": 69,
    "area_code": "233",
    "is_hot": 0,
    "first_letter": "J",
    "sort": 0
  },
  {
    "id": 70,
    "area_code": "350",
    "is_hot": 0,
    "first_letter": "Z",
    "sort": 0
  },
  {
    "id": 71,
    "area_code": "220",
    "is_hot": 0,
    "first_letter": "G",
    "sort": 0
  },
  {
    "id": 72,
    "area_code": "224",
    "is_hot": 0,
    "first_letter": "J",
    "sort": 0
  },
  {
    "id": 73,
    "area_code": "30",
    "is_hot": 0,
    "first_letter": "X",
    "sort": 0
  },
  {
    "id": 74,
    "area_code": "502",
    "is_hot": 0,
    "first_letter": "W",
    "sort": 0
  },
  {
    "id": 75,
    "area_code": "1671",
    "is_hot": 0,
    "first_letter": "G",
    "sort": 0
  },
  {
    "id": 76,
    "area_code": "592",
    "is_hot": 0,
    "first_letter": "G",
    "sort": 0
  },
  {
    "id": 77,
    "area_code": "504",
    "is_hot": 0,
    "first_letter": "H",
    "sort": 0
  },
  {
    "id": 78,
    "area_code": "509",
    "is_hot": 0,
    "first_letter": "H",
    "sort": 0
  },
  {
    "id": 79,
    "area_code": "36",
    "is_hot": 0,
    "first_letter": "X",
    "sort": 0
  },
  {
    "id": 80,
    "area_code": "62",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 81,
    "area_code": "353",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 82,
    "area_code": "972",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 83,
    "area_code": "91",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 84,
    "area_code": "964",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 85,
    "area_code": "98",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 86,
    "area_code": "354",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 87,
    "area_code": "39",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 88,
    "area_code": "225",
    "is_hot": 0,
    "first_letter": "K",
    "sort": 0
  },
  {
    "id": 89,
    "area_code": "1876",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 90,
    "area_code": "962",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 91,
    "area_code": "81",
    "is_hot": 1,
    "first_letter": "R",
    "sort": 0
  },
  {
    "id": 92,
    "area_code": "254",
    "is_hot": 0,
    "first_letter": "K",
    "sort": 0
  },
  {
    "id": 93,
    "area_code": "331",
    "is_hot": 0,
    "first_letter": "J",
    "sort": 0
  },
  {
    "id": 94,
    "area_code": "855",
    "is_hot": 0,
    "first_letter": "J",
    "sort": 0
  },
  {
    "id": 95,
    "area_code": "850",
    "is_hot": 0,
    "first_letter": "C",
    "sort": 0
  },
  {
    "id": 96,
    "area_code": "82",
    "is_hot": 0,
    "first_letter": "H",
    "sort": 0
  },
  {
    "id": 97,
    "area_code": "225",
    "is_hot": 0,
    "first_letter": "K",
    "sort": 0
  },
  {
    "id": 98,
    "area_code": "965",
    "is_hot": 0,
    "first_letter": "K",
    "sort": 0
  },
  {
    "id": 99,
    "area_code": "327",
    "is_hot": 0,
    "first_letter": "H",
    "sort": 0
  },
  {
    "id": 100,
    "area_code": "856",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 101,
    "area_code": "961",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 102,
    "area_code": "1758",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 103,
    "area_code": "423",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 104,
    "area_code": "94",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 105,
    "area_code": "231",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 106,
    "area_code": "266",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 107,
    "area_code": "370",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 108,
    "area_code": "352",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 109,
    "area_code": "371",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 110,
    "area_code": "218",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 111,
    "area_code": "212",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 112,
    "area_code": "377",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 113,
    "area_code": "373",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 114,
    "area_code": "261",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 115,
    "area_code": "223",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 116,
    "area_code": "95",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 117,
    "area_code": "976",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 118,
    "area_code": "1664",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 119,
    "area_code": "356",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 120,
    "area_code": "1670",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 121,
    "area_code": "596",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 122,
    "area_code": "230",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 123,
    "area_code": "960",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 124,
    "area_code": "265",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 125,
    "area_code": "52",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 126,
    "area_code": "60",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 127,
    "area_code": "258",
    "is_hot": 0,
    "first_letter": "M",
    "sort": 0
  },
  {
    "id": 128,
    "area_code": "264",
    "is_hot": 0,
    "first_letter": "N",
    "sort": 0
  },
  {
    "id": 129,
    "area_code": "977",
    "is_hot": 0,
    "first_letter": "N",
    "sort": 0
  },
  {
    "id": 130,
    "area_code": "234",
    "is_hot": 0,
    "first_letter": "N",
    "sort": 0
  },
  {
    "id": 131,
    "area_code": "505",
    "is_hot": 0,
    "first_letter": "N",
    "sort": 0
  },
  {
    "id": 132,
    "area_code": "31",
    "is_hot": 0,
    "first_letter": "H",
    "sort": 0
  },
  {
    "id": 133,
    "area_code": "47",
    "is_hot": 0,
    "first_letter": "N",
    "sort": 0
  },
  {
    "id": 134,
    "area_code": "977",
    "is_hot": 0,
    "first_letter": "N",
    "sort": 0
  },
  {
    "id": 135,
    "area_code": "599",
    "is_hot": 0,
    "first_letter": "H",
    "sort": 0
  },
  {
    "id": 136,
    "area_code": "674",
    "is_hot": 0,
    "first_letter": "N",
    "sort": 0
  },
  {
    "id": 137,
    "area_code": "64",
    "is_hot": 0,
    "first_letter": "X",
    "sort": 0
  },
  {
    "id": 138,
    "area_code": "968",
    "is_hot": 0,
    "first_letter": "A",
    "sort": 0
  },
  {
    "id": 139,
    "area_code": "507",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 140,
    "area_code": "51",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 141,
    "area_code": "689",
    "is_hot": 0,
    "first_letter": "F",
    "sort": 0
  },
  {
    "id": 142,
    "area_code": "675",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 143,
    "area_code": "63",
    "is_hot": 0,
    "first_letter": "F",
    "sort": 0
  },
  {
    "id": 144,
    "area_code": "92",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 145,
    "area_code": "48",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 146,
    "area_code": "1787",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 147,
    "area_code": "351",
    "is_hot": 0,
    "first_letter": "P",
    "sort": 0
  },
  {
    "id": 148,
    "area_code": "595",
    "is_hot": 0,
    "first_letter": "B",
    "sort": 0
  },
  {
    "id": 149,
    "area_code": "974",
    "is_hot": 0,
    "first_letter": "K",
    "sort": 0
  },
  {
    "id": 150,
    "area_code": "262",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 151,
    "area_code": "40",
    "is_hot": 0,
    "first_letter": "L",
    "sort": 0
  },
  {
    "id": 152,
    "area_code": "7",
    "is_hot": 0,
    "first_letter": "E",
    "sort": 0
  },
  {
    "id": 153,
    "area_code": "966",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 154,
    "area_code": "677",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 155,
    "area_code": "248",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 156,
    "area_code": "249",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 157,
    "area_code": "46",
    "is_hot": 0,
    "first_letter": "R",
    "sort": 0
  },
  {
    "id": 158,
    "area_code": "65",
    "is_hot": 0,
    "first_letter": "X",
    "sort": 0
  },
  {
    "id": 159,
    "area_code": "386",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 160,
    "area_code": "421",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 161,
    "area_code": "232",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 162,
    "area_code": "378",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 163,
    "area_code": "684",
    "is_hot": 0,
    "first_letter": "D",
    "sort": 0
  },
  {
    "id": 164,
    "area_code": "685",
    "is_hot": 0,
    "first_letter": "X",
    "sort": 0
  },
  {
    "id": 165,
    "area_code": "221",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 166,
    "area_code": "252",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 167,
    "area_code": "597",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 168,
    "area_code": "239",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 169,
    "area_code": "503",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 170,
    "area_code": "963",
    "is_hot": 0,
    "first_letter": "X",
    "sort": 0
  },
  {
    "id": 171,
    "area_code": "268",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 172,
    "area_code": "235",
    "is_hot": 0,
    "first_letter": "Z",
    "sort": 0
  },
  {
    "id": 173,
    "area_code": "228",
    "is_hot": 0,
    "first_letter": "D",
    "sort": 0
  },
  {
    "id": 174,
    "area_code": "66",
    "is_hot": 0,
    "first_letter": "T",
    "sort": 0
  },
  {
    "id": 175,
    "area_code": "992",
    "is_hot": 0,
    "first_letter": "T",
    "sort": 0
  },
  {
    "id": 176,
    "area_code": "993",
    "is_hot": 0,
    "first_letter": "T",
    "sort": 0
  },
  {
    "id": 177,
    "area_code": "216",
    "is_hot": 0,
    "first_letter": "T",
    "sort": 0
  },
  {
    "id": 178,
    "area_code": "676",
    "is_hot": 0,
    "first_letter": "T",
    "sort": 0
  },
  {
    "id": 179,
    "area_code": "90",
    "is_hot": 0,
    "first_letter": "T",
    "sort": 0
  },
  {
    "id": 180,
    "area_code": "1809",
    "is_hot": 0,
    "first_letter": "T",
    "sort": 0
  },
  {
    "id": 182,
    "area_code": "255",
    "is_hot": 0,
    "first_letter": "T",
    "sort": 0
  },
  {
    "id": 183,
    "area_code": "380",
    "is_hot": 0,
    "first_letter": "W",
    "sort": 0
  },
  {
    "id": 184,
    "area_code": "256",
    "is_hot": 0,
    "first_letter": "W",
    "sort": 0
  },
  {
    "id": 186,
    "area_code": "598",
    "is_hot": 0,
    "first_letter": "W",
    "sort": 0
  },
  {
    "id": 187,
    "area_code": "233",
    "is_hot": 0,
    "first_letter": "W",
    "sort": 0
  },
  {
    "id": 188,
    "area_code": "1784",
    "is_hot": 0,
    "first_letter": "S",
    "sort": 0
  },
  {
    "id": 189,
    "area_code": "58",
    "is_hot": 0,
    "first_letter": "W",
    "sort": 0
  },
  {
    "id": 190,
    "area_code": "84",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 191,
    "area_code": "967",
    "is_hot": 0,
    "first_letter": "Y",
    "sort": 0
  },
  {
    "id": 192,
    "area_code": "381",
    "is_hot": 0,
    "first_letter": "N",
    "sort": 0
  },
  {
    "id": 193,
    "area_code": "27",
    "is_hot": 0,
    "first_letter": "N",
    "sort": 0
  },
  {
    "id": 194,
    "area_code": "260",
    "is_hot": 0,
    "first_letter": "Z",
    "sort": 0
  },
  {
    "id": 195,
    "area_code": "243",
    "is_hot": 0,
    "first_letter": "Z",
    "sort": 0
  },
  {
    "id": 196,
    "area_code": "263",
    "is_hot": 0,
    "first_letter": "J",
    "sort": 0
  }
] as const;

export type AreaCodeItem = (typeof AREA_CODE_LIST)[number];

export const AREA_CODE_NAME_FALLBACK: Record<number, string> = {
  "1": "中國",
  "2": "中國香港",
  "3": "中國臺灣",
  "4": "美國",
  "7": "中國澳門",
  "8": "安道爾共和國",
  "9": "阿拉伯聯合酋長國",
  "10": "阿富汗",
  "11": "安提瓜和巴布達",
  "12": "安圭拉島",
  "13": "阿爾巴尼亞",
  "14": "亞美尼亞",
  "15": "阿森松",
  "16": "安哥拉",
  "17": "阿根廷",
  "18": "奧地利",
  "19": "澳大利亞",
  "20": "阿塞拜疆",
  "21": "巴巴多斯",
  "22": "孟加拉國",
  "23": "比利時",
  "24": "布基納法索",
  "25": "保加利亞",
  "26": "巴林",
  "27": "布隆迪",
  "28": "貝寧",
  "29": "巴勒斯坦",
  "30": "百慕大群島",
  "31": "文萊",
  "32": "玻利維亞",
  "33": "巴西",
  "34": "巴哈馬",
  "35": "博茨瓦納",
  "36": "白俄羅斯",
  "37": "伯利茲",
  "38": "加拿大",
  "39": "開曼群島",
  "40": "中非共和國",
  "41": "剛果",
  "42": "瑞士",
  "43": "庫克群島",
  "44": "智利",
  "45": "喀麥隆",
  "46": "哥倫比亞",
  "47": "哥斯達黎加",
  "48": "古巴",
  "49": "塞浦路斯",
  "50": "捷克",
  "51": "德國",
  "52": "吉布提",
  "53": "丹麥",
  "54": "多米尼加共和國",
  "55": "阿爾及利亞",
  "56": "厄瓜多爾",
  "57": "愛沙尼亞",
  "58": "埃及",
  "59": "西班牙",
  "60": "埃塞俄比亞",
  "61": "芬蘭",
  "62": "斐濟",
  "63": "法國",
  "64": "加蓬",
  "65": "英國",
  "66": "格林納達",
  "67": "格魯吉亞",
  "68": "法屬圭亞那",
  "69": "加納",
  "70": "直布羅陀",
  "71": "岡比亞",
  "72": "幾內亞",
  "73": "希臘",
  "74": "危地馬拉",
  "75": "關島",
  "76": "圭亞那",
  "77": "洪都拉斯",
  "78": "海地",
  "79": "匈牙利",
  "80": "印度尼西亞",
  "81": "愛爾蘭",
  "82": "以色列",
  "83": "印度",
  "84": "伊拉克",
  "85": "伊朗",
  "86": "冰島",
  "87": "意大利",
  "88": "科特迪瓦",
  "89": "牙買加",
  "90": "約旦",
  "91": "日本",
  "92": "肯尼亞",
  "93": "吉爾吉斯坦",
  "94": "柬埔寨",
  "95": "朝鮮",
  "96": "韓國",
  "97": "科特迪瓦共和國",
  "98": "科威特",
  "99": "哈薩克斯坦",
  "100": "老撾",
  "101": "黎巴嫩",
  "102": "聖盧西亞",
  "103": "列支敦士登",
  "104": "斯裏蘭卡",
  "105": "利比裏亞",
  "106": "萊索托",
  "107": "立陶宛",
  "108": "盧森堡",
  "109": "拉脫維亞",
  "110": "利比亞",
  "111": "摩洛哥",
  "112": "摩納哥",
  "113": "摩爾多瓦",
  "114": "馬達加斯加",
  "115": "馬裏",
  "116": "緬甸",
  "117": "蒙古",
  "118": "蒙特塞拉特島",
  "119": "馬耳他",
  "120": "馬裏亞那群島",
  "121": "馬提尼克",
  "122": "毛裏求斯",
  "123": "馬爾代夫",
  "124": "馬拉維",
  "125": "墨西哥",
  "126": "馬來西亞",
  "127": "莫桑比克",
  "128": "納米比亞",
  "129": "尼日爾",
  "130": "尼日利亞",
  "131": "尼加拉瓜",
  "132": "荷蘭",
  "133": "挪威",
  "134": "尼泊爾",
  "135": "荷屬安的列斯",
  "136": "瑙魯",
  "137": "新西蘭",
  "138": "阿曼",
  "139": "巴拿馬",
  "140": "秘魯",
  "141": "法屬玻利尼西亞",
  "142": "巴布亞新幾內亞",
  "143": "菲律賓",
  "144": "巴基斯坦",
  "145": "波蘭",
  "146": "波多黎各",
  "147": "葡萄牙",
  "148": "巴拉圭",
  "149": "卡塔爾",
  "150": "留尼旺",
  "151": "羅馬尼亞",
  "152": "俄羅斯",
  "153": "沙特阿拉伯",
  "154": "所羅門群島",
  "155": "塞舌爾",
  "156": "蘇丹",
  "157": "瑞典",
  "158": "新加坡",
  "159": "斯洛文尼亞",
  "160": "斯洛伐克",
  "161": "塞拉利昂",
  "162": "聖馬力諾",
  "163": "東薩摩亞(美)",
  "164": "西薩摩亞",
  "165": "塞內加爾",
  "166": "索馬裏",
  "167": "蘇裏南",
  "168": "聖多美和普林西比",
  "169": "薩爾瓦多",
  "170": "敘利亞",
  "171": "斯威士蘭",
  "172": "乍得",
  "173": "多哥",
  "174": "泰國",
  "175": "塔吉克斯坦",
  "176": "土庫曼斯坦",
  "177": "突尼斯",
  "178": "湯加",
  "179": "土耳其",
  "180": "特立尼達和多巴哥",
  "182": "坦桑尼亞",
  "183": "烏克蘭",
  "184": "烏幹達",
  "186": "烏拉圭",
  "187": "烏茲別克斯坦",
  "188": "聖文森特島",
  "189": "委內瑞拉",
  "190": "越南",
  "191": "也門",
  "192": "南斯拉夫",
  "193": "南非",
  "194": "贊比亞",
  "195": "紮伊爾",
  "196": "津巴布韋"
};
